import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { LeadCustomFieldRow } from "@/lib/partner-api";
import { slugifyCustomFieldKey } from "@/lib/partner-api";

const MAX_FIELDS = 50;

export function LeadCustomFieldsInputs({
  rows,
  onChange,
}: {
  rows: LeadCustomFieldRow[];
  onChange: (rows: LeadCustomFieldRow[]) => void;
}) {
  const addRow = () => {
    if (rows.length >= MAX_FIELDS) return;
    onChange([...rows, { id: crypto.randomUUID(), key: "", value: "" }]);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <div>
          <p className="text-sm font-medium">Campos personalizados</p>
          <p className="text-xs text-muted-foreground">
            Exclusivos deste lead. A API lê e grava as mesmas chaves em custom_fields.
          </p>
        </div>
        <Button type="button" size="sm" variant="outline" onClick={addRow} disabled={rows.length >= MAX_FIELDS}>
          <Plus className="h-3.5 w-3.5 mr-1.5" />
          Adicionar
        </Button>
      </div>

      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">Nenhum campo extra neste lead.</p>
      ) : (
        <div className="space-y-2">
          {rows.map((row) => (
            <div key={row.id} className="grid gap-2 sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] items-end">
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">Chave</Label>
                <Input
                  value={row.key}
                  onChange={(e) =>
                    onChange(rows.map((r) => (r.id === row.id ? { ...r, key: e.target.value } : r)))
                  }
                  onBlur={() => {
                    const slug = slugifyCustomFieldKey(row.key);
                    if (slug !== row.key) {
                      onChange(rows.map((r) => (r.id === row.id ? { ...r, key: slug } : r)));
                    }
                  }}
                  placeholder="placa"
                />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs text-muted-foreground">Valor</Label>
                <Input
                  value={row.value}
                  onChange={(e) =>
                    onChange(rows.map((r) => (r.id === row.id ? { ...r, value: e.target.value } : r)))
                  }
                  placeholder="ABC1D23"
                />
              </div>
              <Button
                type="button"
                size="icon"
                variant="ghost"
                className="h-10 w-10 text-destructive hover:text-destructive"
                onClick={() => onChange(rows.filter((r) => r.id !== row.id))}
                aria-label="Remover campo"
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
